/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, shape, arrayOf, string, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Toolbar from './Config/Toolbar';
import { DefaultTools } from './Config/Default';

const styles = (theme) => ({
    root: {
        position: 'relative',
        minWidth: '300px',
        maxWidth: '300px',
        [theme.breakpoints.down(1660)]: {
            maxWidth: '260px',
            minWidth: '260px',
        },
    },
    rootLabelHangtag: {
        '@media screen and (min-width: 960px) and (max-width: 1290px)': {
            maxWidth: '180px',
            minWidth: '180px',
            top: '-30px',
        },
    },
    rootMultiple: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '150px',
            minWidth: '150px',
            position: 'relative',
        },
    },
    textarea: {
        minWidth: '250px',
        minHeight: '250px',
        maxWidth: '300px',
        maxHeight: '300px',
        outline: 'none',
        border: `1px dashed ${theme.palette.cgc?.cgcTextBorderColor || '#111'}`,
    },
});

const CgcEditor = ({
    classes, handleStyle, style, toolbarProps, greetingCard,
}) => {
    const mobileResolution = useMediaQuery('(max-width: 600px)'); // for mobile resolution
    const handleStyles = (type, value) => {
        const styleObj = { ...style };
        styleObj[type] = value;
        handleStyle(styleObj);
    };
    let cardViewStyle = '';
    if (!greetingCard) {
        cardViewStyle = classes.rootLabelHangtag;
    }
    return (
        <div className={`${mobileResolution ? classes.rootMultiple : classes.root} ${cardViewStyle}`}>
            <Toolbar config={toolbarProps || DefaultTools} setStyle={handleStyles} />
        </div>
    );
};

CgcEditor.propTypes = {
    classes: object.isRequired,
    handleStyle: func,
    style: object.isRequired,
    toolbarProps: arrayOf(shape({
        max_char: string,
        title: string.isRequired,
        family_name_cards: string,
    })),
    greetingCard: bool,
};

CgcEditor.defaultProps = {
    handleStyle: () => {},
    toolbarProps: null,
    greetingCard: false,
};

export default withStyles(styles)(CgcEditor);
